import React from 'react'
import PropTypes from 'prop-types'

import Field from 'component/utils/Field'
import Form from 'component/utils/Form'
import SearchInput from '../SearchInput'

const FIELDS = ['genericSearch']

const UpperFilterForm = ({ fields, submit, translate, values }) => {
  const beforeSubmit = () => {
    submit(values)
  }

  const handleOnChange = (event) => {
    fields.genericSearch.input.onChange(event)
  }

  const onClear = () => {
    fields.genericSearch.input.onChange({ target: { value: '' } })
    submit({ genericSearch: '' })
  }

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <Field {...fields.genericSearch} ignoreActiveClass>
        <SearchInput
          {...fields.genericSearch.input}
          className='mission-block-mission-input-square'
          maxLength={100}
          placeholder={translate('missionMenu.filter.genericPlaceholder')}
          onChange={handleOnChange}
          onSearch={beforeSubmit}
          onClear={onClear}
          value={values.genericSearch}
          clearable
        />
      </Field>
    </form>
  )
}

UpperFilterForm.propTypes = {
  fields: PropTypes.object.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  initialValues: PropTypes.object,
}

export default Form({ fields: FIELDS })(UpperFilterForm)

export { UpperFilterForm }
